<template>
  <div class="container">
    <van-nav-bar title="抄表录入" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="menu">
      <van-field readonly clickable label="抄表项目" :value="communityName" placeholder="请选择" @click="showPicker" />
      <van-field readonly label="抄表时间" :value="time" placeholder="" />
    </div>
    <div class="mg12" v-if="meterList.length == 0 && communityId">
      <van-field center readonly label-width="200" label="该项目还没有表具，请先" placeholder="" >
        <template #button>
          <van-button size="small" type="info" @click="changePage('addMeter')">新增表具</van-button>
        </template>
      </van-field>
    </div>
    <van-popup v-model="showPopup" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="showPopup = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>

    <div class="listbox" v-if="meterList.length > 0">
      <van-row>
        <van-col span="2">NO.</van-col>
        <van-col span="5">电表编号</van-col>
        <van-col span="5">上期读数</van-col>
        <van-col span="7">本期读数</van-col>
        <van-col span="5">本期电量</van-col>
      </van-row>
      <van-row :key="index" v-for="(item,index) in meterList">
        <van-col span="2">{{index+1}}</van-col>
        <van-col span="5">{{item.meterNum}}</van-col>
        <van-col span="5">{{item.startValue}}</van-col>
        <van-col span="7">
          <van-stepper input-width="60px" button-size="22px" @change="getTotalDegree" v-model="item.endValue" :min="item.startValue" step="1" :decimal-length="1" />
        </van-col>
        <van-col span="5">{{item.endValue - item.startValue}}</van-col>
      </van-row>
    </div>

    <div class="botBox clearfix">
      <div class="fl_left">
        <span class="lab">本期总电量</span>
        <span class="val col_b">{{totalDegree.toFixed(2)}}</span>
      </div>
      <div class="fl_right">
        <van-button round type="info" :disabled="meterList == 0" @click="writeMeterDegree">下一步</van-button>
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Button,Picker,Field,Popup,List,Col,Row,Stepper} from 'vant';
  export default {
    data() {
      return {
        time: '',
        id:'',
        communityId:'',
        communityName: '',
        showPopup: false,
        totalDegree: 0,
        columns: [],
        meterList:[],
        cityList:[],
        communityList:[],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Picker.name]:Picker,
      [Popup.name]:Popup,
      [List.name]:List,
      [Col.name]:Col,
      [Row.name]:Row,
      [Stepper.name]:Stepper,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html",query:{communityId:this.communityId,communityName:this.communityName}});
      },
      showPicker(){
        this.showPopup = true;
        this.columns = [
          // 第一列
          {
            values: this.cityList,
            defaultIndex: 0,
          },
          // 第二列
          {
            values: this.communityList,
            defaultIndex: 0,
          },
        ];
        
      },
      onChange(picker,item, index) {
        if(index == 0){
          this.cityCode = item[0].id;
          this.getCommunityList(picker);
        }
      },
      onConfirm(item) {
        this.communityName = item[1].name;
        this.communityId = item[1].id;
        this.getMeterList();
        this.showPopup = false;
      },
      getCityList() {
        axios.get("/common/getcitylist?proviceId=410000").then((res)=>{
          this.cityList = res.data;
        })
      },
      getCommunityList(picker) {
        axios.post("/common/getcommunitylistbycitycode",{
          cityCode: this.cityCode,
        }).then((res)=>{
          if(res.data.length > 0){
            res.data.forEach(item=>{
              item.name = item.communityName
              item.id = item.communityId
            })
          }
          this.communityList = res.data;
          if(picker){
            picker.setColumnValues(1,res.data);
          }
          
        })
      },
      getMeterList() {
        axios.get("/meteruploaddegree/getmeteruselist?communityId="+this.communityId).then((res)=>{
          if(res.data){
            this.id = res.data.id;
            this.meterList = res.data.meterUseList;
            this.communityId = res.data.communityId;
            this.communityName = res.data.communityName;
            this.time = res.data.endTime;
            this.getTotalDegree();
          }else{
            this.meterList = [];
            this.time = '';
            this.totalDegree = 0;
          }
        })
      },
      getTotalDegree(){
        var totalDegree = 0;
        if(this.meterList.length > 0){
          this.meterList.forEach(item=>{
            item.endValue = item.endValue == 0?item.startValue:item.endValue;
            item.totalDegree = item.endValue - item.startValue;
            totalDegree += (item.endValue - item.startValue)
          })
        }
        this.totalDegree = totalDegree;
      },
      writeMeterDegree() {
        axios.post("/meteruploaddegree/writemeterdegree",{
          id:this.id,
          communityId: this.communityId,
          meterUseList: this.meterList
        }).then((res)=>{
          if(res.isSuccess){
            this.$router.push({path: "uploadBill.html",query:{id:res.data}})
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      this.communityId = this.$route.query.communityId;
      if(this.communityId){
        this.getMeterList();
      }
      this.getCityList();
      this.getCommunityList();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    .van-row{
      border-bottom: 1px solid #F0F4F7;
    }
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .botBox{
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 12px;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
    .lab{
      margin-right: 10px;
    }
    .van-button{width: 170px;line-height: 60px;}
  }
  .mg12{margin-top: 12px;}
</style>
